export const GROWTH = {
    value: "GROWTH",
    key: "clients.client.categorisation.financialForm.form.marketSituationTypes.growth",
};

export const STABLE = {
    value: "STABLE",
    key: "clients.client.categorisation.financialForm.form.marketSituationTypes.stable",
};

export const DANGER = {
    value: "DANGER",
    key: "clients.client.categorisation.financialForm.form.marketSituationTypes.danger",
};

export const FOR_SALE = {
    value: "FOR_SALE",
    key: "clients.client.categorisation.financialForm.form.marketSituationTypes.forSale",
};

export const TERMINATION = {
    value: "TERMINATION",
    key: "clients.client.categorisation.financialForm.form.marketSituationTypes.termination",
};

export const DECREASE = {
    value: "DECREASE",
    key: "clients.client.categorisation.financialForm.form.marketSituationTypes.decrease"
};

export default [GROWTH, STABLE, DANGER, FOR_SALE, TERMINATION, DECREASE];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/enums/categorisationMarketSituationTypes.js